// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Rollbar from "../../../../node_modules/rescript-rollbar/lib/es6_global/src/Rollbar.bs.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Caml_exceptions from "../../../../node_modules/rescript/lib/es6/caml_exceptions.js";
import * as Caml_js_exceptions from "../../../../node_modules/rescript/lib/es6/caml_js_exceptions.js";
import * as PromiseUtils$Showside from "./PromiseUtils.bs.js";
import * as RollbarInstance$Showside from "./RollbarInstance.bs.js";
var SwymitError = /* @__PURE__ */Caml_exceptions.create("SwymitWishlist-Showside.SwymitError");
var Unsupported = /* @__PURE__ */Caml_exceptions.create("SwymitWishlist-Showside.Unsupported");
function ext_isSupported(param) {
  return window._swat !== undefined;
}
function ext_isReadyToUse(param) {
  return Belt_Option.flatMap(window._swat, function (swat) {
    return swat.fetchWishlistCount;
  }) !== undefined;
}
function handleError(promise) {
  return PromiseUtils$Showside.$$catch(promise, function (originalExn) {
    var message;
    if (originalExn.RE_EXN_ID === SwymitError) {
      var message$1 = originalExn._1;
      message = message$1.trim() !== "" ? "[swymit] " + message$1 : "[swymit] Unknown error occurred while interacting with Swymit API";
    } else {
      message = "[swymit] Unknown error occurred while interacting with Swymit API";
    }
    var err = originalExn.RE_EXN_ID === SwymitError ? originalExn._2 : originalExn;
    var jsExn = Rollbar.$$Error.fromRescript(err);
    var rootCause = Rollbar.$$Error.getRootCause(jsExn);
    var match = rootCause.message;
    var match$1 = rootCause.name;
    var rootCauseMessage = match !== undefined ? match$1 !== undefined ? "RC: " + match$1 + " " + match + "" : "RC: " + match + "" : match$1 !== undefined ? "RC: " + match$1 + "" : undefined;
    var message$2 = Belt_Array.keepMap([message, rootCauseMessage], function (a) {
      return a;
    }).join(", ");
    RollbarInstance$Showside.jsError2(Rollbar.$$Error.fromStringWithCause(message$2, rootCause), message$2);
    return Promise.reject(err);
  });
}
function ext_useCallback(callback) {
  React.useEffect(function () {
    var callbacks = window.SwymCallbacks;
    window.SwymCallbacks = callbacks !== undefined ? Belt_Array.concat(callbacks, [callback]) : [callback];
    return function (param) {
      var callbacks = window.SwymCallbacks;
      window.SwymCallbacks = callbacks !== undefined ? Belt_Array.keep(callbacks, function (cb) {
        return cb !== callback;
      }) : [];
    };
  }, []);
}
function ext_addItem(link) {
  return handleError(new Promise(function (resolve, reject) {
    if (link !== undefined) {
      return Belt_Option.forEach(window._swat, function (swat) {
        try {
          swat.addToWishlistUsingDu({
            du: link,
            source: "collections-grid"
          }, function (count) {
            resolve(undefined);
          });
          return;
        } catch (raw_e) {
          var e = Caml_js_exceptions.internalToOCamlException(raw_e);
          return reject({
            RE_EXN_ID: SwymitError,
            _1: "Add to wishlist failed",
            _2: e
          });
        }
      });
    } else {
      return reject({
        RE_EXN_ID: SwymitError,
        _1: "No link provided",
        _2: {
          RE_EXN_ID: Unsupported
        }
      });
    }
  }));
}
function ext_removeItem(link) {
  return handleError(new Promise(function (resolve, reject) {
    if (link !== undefined) {
      return Belt_Option.forEach(window._swat, function (swat) {
        try {
          swat.removeFromWishlistUsingDu({
            du: link,
            source: "collections-grid"
          }, function (count) {
            resolve(undefined);
          });
          return;
        } catch (raw_e) {
          var e = Caml_js_exceptions.internalToOCamlException(raw_e);
          return reject({
            RE_EXN_ID: SwymitError,
            _1: "Remove from wishlist failed",
            _2: e
          });
        }
      });
    } else {
      return reject({
        RE_EXN_ID: SwymitError,
        _1: "No link provided",
        _2: {
          RE_EXN_ID: Unsupported
        }
      });
    }
  }));
}
function ext_getCount(param) {
  return handleError(new Promise(function (resolve, reject) {
    Belt_Option.forEach(Belt_Option.flatMap(window._swat, function (prim) {
      return prim.fetchWishlistCount;
    }), function (callback) {
      try {
        return Curry._2(callback, function (param) {
          resolve(param.data.count);
        }, function (error) {
          reject({
            RE_EXN_ID: SwymitError,
            _1: "Failed to get wishlist count",
            _2: error
          });
        });
      } catch (raw_e) {
        var e = Caml_js_exceptions.internalToOCamlException(raw_e);
        return reject({
          RE_EXN_ID: SwymitError,
          _1: "Failed to get wishlist count",
          _2: e
        });
      }
    });
  }));
}
function ext_isInWishlist(variantId) {
  return handleError(new Promise(function (resolve, reject) {
    Belt_Option.forEach(window._swat, function (swat) {
      try {
        swat.isInWishlist({
          epi: variantId
        }, function (isInWishlist) {
          resolve(isInWishlist);
        });
        return;
      } catch (raw_e) {
        var e = Caml_js_exceptions.internalToOCamlException(raw_e);
        return reject({
          RE_EXN_ID: SwymitError,
          _1: "Failed to check if product is in wishlist",
          _2: e
        });
      }
    });
  }));
}
var context = React.createContext({
  add: function (param) {
    return Promise.reject({
      RE_EXN_ID: Unsupported
    });
  },
  remove: function (param) {
    return Promise.reject({
      RE_EXN_ID: Unsupported
    });
  },
  isAdded: function (param) {
    return Promise.reject({
      RE_EXN_ID: Unsupported
    });
  },
  count: 0,
  loaded: false,
  supported: false
});
var provider = context.Provider;
function SwymitWishlist$Provider(Props) {
  var children = Props.children;
  var match = React.useState(function () {
    return ext_isReadyToUse(undefined);
  });
  var setLoaded = match[1];
  var loaded = match[0];
  var match$1 = React.useState(function () {
    return 0;
  });
  var setCount = match$1[1];
  var supported = window._swat !== undefined;
  ext_useCallback(function (swat) {
    Curry._1(setLoaded, function (param) {
      return ext_isReadyToUse(undefined);
    });
  });
  var updateCount = function (param) {
    if (loaded) {
      ext_getCount(undefined).then(function (count) {
        Curry._1(setCount, function (param) {
          return count;
        });
      });
      return;
    }
  };
  React.useEffect(function () {
    updateCount(undefined);
    var evtLayer = Belt_Option.flatMap(window._swat, function (prim) {
      return prim.evtLayer;
    });
    if (evtLayer === undefined) {
      return;
    }
    var evtLayer$1 = Caml_option.valFromOption(evtLayer);
    evtLayer$1.addEventListener("sw:addedtowishlist", updateCount);
    evtLayer$1.addEventListener("sw:removedfromwishlist", updateCount);
    return function (param) {
      evtLayer$1.removeEventListener("sw:addedtowishlist", updateCount);
      evtLayer$1.removeEventListener("sw:removedfromwishlist", updateCount);
    };
  }, [loaded]);
  var handleAdd = function (link) {
    return ext_addItem(link).then(function (param) {
      updateCount(undefined);
    });
  };
  var handleRemove = function (link) {
    return ext_removeItem(link).then(function (param) {
      updateCount(undefined);
    });
  };
  var isAdded = ext_isInWishlist;
  var ctx_count = match$1[0];
  var ctx = {
    add: handleAdd,
    remove: handleRemove,
    isAdded: isAdded,
    count: ctx_count,
    loaded: loaded,
    supported: supported
  };
  return React.createElement(provider, {
    value: ctx,
    children: children
  });
}
SwymitWishlist$Provider.displayName = "SwymitWishlist.Provider";
var Provider = {
  context: context,
  provider: provider,
  make: SwymitWishlist$Provider
};
function use(param) {
  return React.useContext(context);
}
export { SwymitError, Unsupported, ext_isSupported, ext_isReadyToUse, handleError, ext_useCallback, ext_addItem, ext_removeItem, ext_getCount, ext_isInWishlist, Provider, use };
/* context Not a pure module */